/*
  Copyright 2018 Experian. All Rights Reserved
*/

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const resources = {


  //identific endpoint

  identific:{
    decodeResponseUsingGET: '/auth/user_data',
    generateTokenUsingGET: '/auth/generate_token',
    getAllUsingGET: '/authentication_log'
  },

  acao:{
    consultarAcao: '/acao',
    consultarAcaoCNJ:'/acao/cnj',
    baixaAcao:'/acao'
  },
  //autenticacao endpoint
  autenticacao:{
    autenticacao: '/oauth/token'
  },

  //vara endpoints
  vara:{
    consultarVara:'/varas/'
  },

  //magistrado endpoints
  magistrado:{
    consultarMagistrado: '/magistrados/'
  },

  //Foro endpoints
  foro:{
    consultarForo: '/foros/'
  },

  usuario:{
    consultaTipoUsuario: '/usuario/tipousuario/'
  },

  //ordem enpoints
  ordem: {
    acao: {
      incluirOrdemAcao: '/ordens/acao',
      consultarOrdemAcao: '/ordens/acao'
    },
    endereco: {
      incluirOrdemEndereco:'/ordens/endereco',
      consultarOrdemEndereco:'/ordens/endereco'
    },
    baixa:{
      incluirOrdemBaixa: ''
    },
    atualizarStatusOrdem: '/ordens/',
    consultarOrdens: '/ordens',
    incluirOrdem: '/ordens/'
  },

  //carta endpoint
  carta:{
    consultarCarta: '/carta/',
    incluirCarta: '/carta/'
  },
  //consumer-registration endpoint
  consumerRegistration:{
    consultarMaiorIdade:'/consumerRegistration/'
  },
  //users-accounts
  userAccounts:{
    me:"/user-accounts/me"
  },

  // iam endpoints
  iam: {
    user: {
      leverageIdentifyStrong: "/user-identities/leverage-identity-strong",
      authIdentityStrong: "/user-identities/auth-identity-strong",
      changeAccount:"/user-identities/change-account"
    },
    client: {
      identity: '/client-identities/identify'
    }
  }

};
